import React, { useCallback } from "react";

import { EntityTypesSupportedColumnSelection } from "@mapmycustomers/shared/types/entity";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";

import useView from "@app/component/view/utils/useView";

import ColumnPane from "./ColumnPane";

export interface SelectColumnsPaneProps {
  entityType: EntityTypesSupportedColumnSelection;
  fieldFilter?: (field: IField) => boolean;
  fixedFields?: IField[];
  onHide: () => void;
  showCategories?: boolean;
  visible: boolean;
}

const SelectColumnsPane: React.FC<SelectColumnsPaneProps> = ({
  entityType,
  fieldFilter,
  fixedFields,
  onHide,
  showCategories,
  visible,
}) => {
  const {
    updateColumnVisibility,
    viewState: { columns },
  } = useView();

  const filter = useCallback(
    (field: IField): boolean => {
      if (!field.isReadable && !field.isSystemRequired) {
        return false;
      } else if (fieldFilter) {
        return fieldFilter(field);
      }

      return true;
    },
    [fieldFilter]
  );

  return (
    <ColumnPane
      columns={columns}
      entityType={entityType}
      fieldFilter={filter}
      fixedFields={fixedFields}
      onHide={onHide}
      onUpdate={updateColumnVisibility}
      showCategories={showCategories}
      visible={visible}
    />
  );
};

export default SelectColumnsPane;
